import React, { useState, useEffect } from 'react'
import { getDaysSinceWeighIn, hostDateToString, todayString } from '../../util'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import IconPause from '../../../../../../images/new-vacation-mode/pause-mode.png'
import { Accordion } from './components/setting-accordion'
import { SaveButton } from './components/save-button'
import styled from 'styled-components'
import { Toggle } from './components/toggle'
import { UserCheckinWarning } from './components/user-check-in-warning'
import CheckinFormPortal from './components/check-in-2-4'
import { modifyUser } from '../../../../../../api'
import helpTip from '../../../../../../images/change-goal-pictures/helpTip.png'
import Icon from '@material-ui/core/Icon'

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`
const HideTargetText = styled.span`
  margin: 0;
  font-weight: bold;
  color: #333;
  font-size: 1rem;

  @media (max-width: 900px) {
    font-size: .9rem !important;
  }
`;

const UpdatePauseMode = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [show, setShow] = useState(false);
  const [showVacationModal, setShowVacationModal] = useState(false);
  const [showHideTargetModal, setShowHideTargetModal] = useState(false);
  const [showLogWeeklyBodyMetricsModal, setShowLogWeeklyBodyMetricsModal] = useState(false);
  const [vacationMode, setVacationMode] = useState(0);
  const [vacationModeInfo, setVacationModeInfo] = useState({
    practice_mode: false,
    log_weekly_body_metrics: false,
    hide_protein: false,
    hide_carbs: false,
    hide_fat: false,
  });
  const [showUserCheckinWarning, setShowUserCheckinWarning] = useState(false);
  const [showCheckinFormPortal, setShowCheckinFormPortal] = useState(false);
  

  useEffect(() => {
    if (props.vacationMode !== null && !props.vacationModeInfo?.practice_mode) {
      setVacationMode(props.vacationMode);
      setVacationModeInfo({
        practice_mode: false,
        log_weekly_body_metrics: props.vacationModeInfo?.log_weekly_body_metrics || false,
        hide_protein: props.vacationModeInfo?.hide_protein || false,
        hide_carbs: props.vacationModeInfo?.hide_carbs || false,
        hide_fat: props.vacationModeInfo?.hide_fat || false,
      });
    }
  }, [props.vacationModeInfo, props.vacationMode]);

  useEffect(() => {
    const vacationModeChanged = vacationMode !== props.vacationMode || vacationModeInfo.practice_mode !== props.vacationModeInfo?.practice_mode;
    const logWeeklyBodyMetricsChanged = vacationModeInfo?.log_weekly_body_metrics !== (props.vacationModeInfo?.log_weekly_body_metrics || false);
    const hideProteinChanged = vacationModeInfo?.hide_protein !== (props.vacationModeInfo?.hide_protein || false);
    const hideCarbsChanged = vacationModeInfo?.hide_carbs !== (props.vacationModeInfo?.hide_carbs || false);
    const hideFatChanged = vacationModeInfo?.hide_fat !== (props.vacationModeInfo?.hide_fat || false);
    
    if (props.vacationModeInfo?.practice_mode === vacationModeInfo.practice_mode) {
      setDisableSubmit(!(vacationModeChanged || logWeeklyBodyMetricsChanged || hideProteinChanged || hideCarbsChanged || hideFatChanged));
    } else if (vacationMode) {
      setDisableSubmit(!vacationModeChanged);
    }
  }, [vacationModeInfo, vacationMode, props.vacationMode, props.vacationModeInfo]);

  const handleToggle = (preferenceKey) => {
    setVacationModeInfo(prev => ({
      ...prev,
      [preferenceKey]: !prev[preferenceKey]
    }));
  };

  const handleSubmit = () => {
    if (props.vacationMode && props.vacationModeInfo?.practice_mode) {
      props.openSnackbar('Practice mode already turned on. Turn off "Practice mode" to continue.', true);
      return;
    }

    if (vacationMode === 0) {
      const todayDateString = todayString();
      if (
        hostDateToString(props.lastWeighInDate) === todayDateString ||
        (props.vacationEntryDate &&
          hostDateToString(props.vacationEntryDate) === todayDateString)
      ) {
        setIsSubmitting(true);
        modifyUser(props.userId, props.portalId, { vacation_mode: 0 })
          .then(() => {
            setIsSubmitting(false);
            setShow(false);
            props.loadPortalAccount();
            props.openSnackbar('Pause your goal mode has been updated successfully', false);
          })
          .catch((err) => {
            setIsSubmitting(false);
            props.openSnackbar('Unable to update Pause your goal mode', true);
          });
      } else {
        setShowVacationModal(true);
      }
    } else {
      const data = {
        vacation_mode: vacationMode,
        vacation_mode_info: vacationModeInfo,
      };
      setIsSubmitting(true);
      modifyUser(props.userId, props.portalId, data)
        .then(() => {
          setIsSubmitting(false);
          setShow(false);
          props.loadPortalAccount();
          props.openSnackbar('Preference saved!', false);
        })
        .catch((err) => {
          setIsSubmitting(false);
          props.openSnackbar('Unable to update preference', true);
        });
    }
  };

  const handleReset = () => {
    if (props.vacationMode && !props.vacationModeInfo?.practice_mode) {
      setVacationMode(props.vacationMode);
      setVacationModeInfo({
        practice_mode: props.vacationModeInfo?.practice_mode || false,
        log_weekly_body_metrics: props.vacationModeInfo?.log_weekly_body_metrics || false,
        hide_protein: props.vacationModeInfo?.hide_protein || false,
        hide_carbs: props.vacationModeInfo?.hide_carbs || false,
        hide_fat: props.vacationModeInfo?.hide_fat || false,
      });
    } else {
      setVacationMode(0);
      setVacationModeInfo({
        practice_mode: false,
        log_weekly_body_metrics: false,
        hide_protein: false,
        hide_carbs: false,
        hide_fat: false,
      });
      setDisableSubmit(true);
    }
  };

  const daysAfterLastCheckIn = getDaysSinceWeighIn(props.lastWeighInDate);

  return (
    <div>
      <Accordion
        show={show}
        setShow={(val) => setShow(val)}
        handleReset={handleReset}
        settingName="Pause your goal"
        icon={IconPause}
        currentSetting={
          props.vacationMode === 1 && !props.vacationModeInfo?.practice_mode ? "On" : "Off"
        }
        alternateColor
      >
        <p>
          Disable check-ins and adjustments whenever you're not actively pursuing your goal or can't focus on hitting your macros–whether you're on vacation, sick, or just want to log food without aiming for a specific goal.
        </p>
        <Toggle
          label="Pause your goal"
          checked={vacationMode !== 0 && !vacationModeInfo?.practice_mode}
          onChange={() => {
            setVacationMode(1 - vacationMode);
            setVacationModeInfo({
              ...vacationModeInfo,
              practice_mode: false,
            });
          }}
          value="vacationMode"
        />
        {vacationMode !== 0 && (
          <>
            <p>&nbsp;</p>
            <p style={{textAlign: 'center'}}>Customize your experience while on Pause Your Goal mode</p>
            <Toggle
              info={true}
              onInfoClick={() => setShowLogWeeklyBodyMetricsModal(true)}
              label="Log weekly body metrics"
              checked={vacationModeInfo?.log_weekly_body_metrics}
              onChange={() => handleToggle('log_weekly_body_metrics')}
              value="logWeeklyBodyMetrics"
            />
            <p>
              Turn on weekly prompts to log weight and body fat. Adherence to
              your macro targets won't be considered and no adjustments will be
              made.
            </p>
            <p>&nbsp;</p>
            <div style={{display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '16px'}}>
              <Icon onClick={() => setShowHideTargetModal(true)} style={{cursor: 'pointer'}}>help_outline</Icon>
              <HideTargetText>Hide macro targets</HideTargetText>
            </div>
            <p>Track food without aiming for macro targets</p>
            <Toggle
              label="Hide Protein"
              checked={vacationModeInfo?.hide_protein}
              onChange={() => handleToggle('hide_protein')}
              value="vacationMode"
            />
            <Toggle
              label="Hide Carbs"
              checked={vacationModeInfo?.hide_carbs}
              onChange={() => handleToggle('hide_carbs')}
              value="vacationMode"
            />
            <Toggle
              label="Hide Fat"
              checked={vacationModeInfo?.hide_fat}
              onChange={() => handleToggle('hide_fat')}
              value="vacationMode"
            />
          </>
        )}
        <ButtonRow>
          <SaveButton
            onClick={handleSubmit}
            isLoading={isSubmitting}
            disabled={disableSubmit}
          />
        </ButtonRow>
      </Accordion>

      <Dialog open={showVacationModal} onClose={() => setShowVacationModal(false)}>
        <DialogContent className='avn-modal-content-container'>
          <img src={IconPause} alt="coaching-icon" />
          <h4>Goal resumed</h4>
          <p>Weekly check-ins and adjustments will now resume! Please enter a new starting weight for them.</p>
          <DialogActions>
            <div className='avn-modal-actions-container'>
              <button className='avn-modal-action' onClick={() => { setShowVacationModal(false); setShowCheckinFormPortal(true) }}>Continue</button>
              <button className='avn-modal-action-cancel' onClick={() => { setShowVacationModal(false) }}>Cancel</button>
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Dialog open={showHideTargetModal} onClose={() => setShowHideTargetModal(false)}>
        <DialogContent className='avn-modal-content-container'>
          <img src={helpTip} alt="coaching-icon" />
          <h4>Why hide your macro targets?</h4>
          <p style={{textAlign: 'center', fontWeight: 'bold'}}>Popular reasons</p>
          <ul>
            <li>You want to log food without the pressure to hit your macros.</li>
            <li>You'd rather focus on food choices than hitting specific targets.</li>
            <li>You only care about hitting certain macros.</li>
          </ul>
          <DialogActions className='avn-modal-actions-container'>
            <button className='avn-modal-action' onClick={() => setShowHideTargetModal(false)}>Ok got it</button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <Dialog open={showLogWeeklyBodyMetricsModal} onClose={() => setShowLogWeeklyBodyMetricsModal(false)}>
        <DialogContent className='avn-modal-content-container'>
          <img src={helpTip} alt="coaching-icon" />
          <h4>Why log weekly body metrics?</h4>
          <p style={{maxWidth: '510px'}}>You'll turn these prompts on when you want to continue tracking body
          changes while your goal is paused. These aren't check-ins–so you don't
          need to hit your macros and you won't receive adjustments–but you will
          be able to record your weight, body fat, body measurements, and
          progress photos each week.</p>
          <DialogActions className='avn-modal-actions-container'>
            <button className='avn-modal-action' onClick={() => setShowLogWeeklyBodyMetricsModal(false)}>Ok got it</button>
          </DialogActions>
        </DialogContent>
      </Dialog>

      <UserCheckinWarning
        open={showUserCheckinWarning}
        onClose={() => setShowUserCheckinWarning(false)}
        daysAfterLastCheckIn={daysAfterLastCheckIn}
      />
      
      <CheckinFormPortal
        skipMessage
        vacationSetting
        open={showCheckinFormPortal}
        onClose={() => setShowCheckinFormPortal(false)}
        openFeedback={props.openSnackbar}
        userId={props.userId}
        portalId={props.portalId}
        loadPortalAccount={props.loadPortalAccount}
        weightString={props.weightString}
        previousWeight={props.previousWeight}
        previousBodyfat={props.previousBodyfat}
        useMetricUnits={props.useMetricUnits}
        daysAfterLastCheckIn={daysAfterLastCheckIn}
        gender={props.gender}
      />
    </div>
  );
};

export default UpdatePauseMode;
